/* eslint-disable */
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router, hashHistory, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import React from 'react';
import _debug from 'debug';
// Material-ui requires this step for handling touch/tap events
import injectTapEventPlugin from 'react-tap-event-plugin';
import { bootstrapAppCallback } from 'lib/network/webapi';
import './styles/root.css';
import './assets/fonts/fonts.css';
import getRoutes from './routes';
import configureStore from './state/store/configureStore';

injectTapEventPlugin();

// Debug logs get enabled on browser console
if (__DEV__) {
  window.localStorage.debug = 'app:*';
}

const debug = _debug('app:root');
const rootElement = document.getElementById('root');
const store = (__MANAGE__) ? configureStore(hashHistory) : configureStore(browserHistory);
const history = (__MANAGE__) ?
  syncHistoryWithStore(hashHistory, store) : syncHistoryWithStore(browserHistory, store);

debug('root bootstrapAppCallback');
bootstrapAppCallback().then(() => {
  if (__PROD__) {
    if (window === window.parent) {
      render(
        <Provider store={store}>
          <Router history={history} key={Date.now()}>{getRoutes(store)}</Router>
        </Provider>,
        rootElement
      );
    }
  } else {
    const HotEnabler = require('react-hot-loader').AppContainer; // eslint-disable-line
    // Waiting on this PR for HotReload error support - https://github.com/facebook/react/pull/6020
    const Redbox = require('redbox-react').default; // eslint-disable-line
    const renderRoute = (routes) => {
      if (window === window.parent) {
        render(
          <HotEnabler errorReporter={Redbox}>
            <Provider store={store} key="provider">
              <div>
                <Router history={history} key={Date.now()}>
                  {routes}
                </Router>
              </div>
            </Provider>
          </HotEnabler>,
          rootElement
        );
      }
    };
    renderRoute(getRoutes(store));
    if (module.hot) {
      module.hot.accept('./routes', () => {
        const nextRoutes = require('./routes').default; // eslint-disable-line
        renderRoute(nextRoutes(store));
      });
    }
  }
});



// WEBPACK FOOTER //
// ./src/root.js